import { useQuery } from 'react-query';
import { baseURL, contactsGet } from 'Types/APITypes';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { Contact } from '../Types';
import { getNewContact } from '../components/Contact/Utils';

// List

const getContactList = (locationNumber: string, accountLevel: string = '', contactType: string = '', limit?: number) => {
  let endpoint = `contacts/${locationNumber}/list?level=${accountLevel}&type=${contactType}`;
  if (limit) endpoint += `&$limit=${limit}`;
  return maestroApiCall({ method: 'GET', endpoint, baseURL });
};

function useContactList({
  stNumber, accountLevel, contactType, queryKey, limit,
}: { stNumber: string, accountLevel: string, contactType: string, queryKey: string | undefined, limit?: number, }) {
  return useQuery(['contact-list', stNumber, accountLevel, contactType, queryKey, limit], () => getContactList(stNumber, accountLevel, contactType, limit));
}

// Delete

const deleteContact = (locationNumber: string, contactId: string) => maestroApiCall(
  { method: 'DELETE', endpoint: `contacts/${locationNumber}/${contactId}`, baseURL },
);

// Get

function getContactDetail(stNumber: string, contactId: string = '', defaultData?: Contact) {
  if (defaultData) return getNewContact(defaultData);
  return maestroApiCall(contactsGet(stNumber || '', contactId || '')).then((data) => {
    // eslint-disable-next-line no-param-reassign
    if (data.visible_externally === '') data.visible_externally = false;
    return data;
  });
}

function useContact({
  stNumber, contactId, defaultData, queryKey,
}: { stNumber: string, contactId: string, defaultData: Contact | undefined, queryKey: string | undefined, }) {
  return useQuery(['contact-detail', stNumber, contactId, queryKey],
    () => getContactDetail(stNumber, contactId, defaultData));
}

// Update / Add

async function updateContactTypes(locationNumber: string, data: any) {
  const apiType: MaestroAPI = { method: 'POST', endpoint: `contacts/${locationNumber}/update-contact-types`, baseURL };
  return maestroApiCall(apiType, data).then((res) => res);
}

async function addContact(locationNumber: string, data: any, basic?: boolean) {
  const endpoint = basic ? `contacts/${locationNumber}?basic=true` : `contacts/${locationNumber}`;
  const apiType: MaestroAPI = { method: 'POST', endpoint, baseURL };
  return maestroApiCall(apiType, data).then((res) => res);
}

async function updateContact(locationNumber: string, contactId: string, data: any, basicFields: boolean) {
  const apiType: MaestroAPI = {
    method: 'PUT',
    endpoint: `contacts/${locationNumber}/${contactId}?basic=${basicFields}`,
    baseURL,
  };
  return maestroApiCall(apiType, data).then((res) => res);
}

export {
  useContactList,
  deleteContact,
  updateContactTypes,
  addContact,
  updateContact,
  useContact,
};
